import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import UpdatePrompt from './components/UpdatePrompt';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import './pwaInstall';
import './visualViewport';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
    <App />
    <UpdatePrompt />
  </>
);

// Service worker: production only. New versions wait for the user to tap
// "Actualizar" (see UpdatePrompt); the page is never reloaded automatically.
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
